const transfers = {
  transfer: "Trasferimento", // translated
  transfers: "Trasferimenti", // translated
  dateAndTime: "Data e ora", // translated
  transferFrom: "Trasferito da", // translated
  duration: "Durata", // translated
  numOfPersons: "Numero di persone", // translated
  baggageAllowance: "Franchigia bagaglio", // translated
  small: "Piccolo", // translated
  big: "Grande", // translated
  provider: "Fornitore", // translated
  vehicle: "Veicolo", // translated
  distance: "Distanza", // translated
  price: "Prezzo", // translated
  inboundJourney: "Viaggio in entrata", // translated
  outboundJourney: "Viaggio di andata", // translated
  arrivalTime: "Orario di arrivo", // translated
  flightDetails: "Dettagli del volo", // translated
  inboundPickupDate: "Data di ritiro in entrata", // translated
  outboundPickupDate: "Data di ritiro in uscita", // translated
  travelInfo: "Informazioni di viaggio", // translated
  flightsInfo: "Informazioni sui voli", // translated
  airportYouAreFlyingFrom: "Aeroporto da cui voli", // translated
  airportYouAreFlyingTo: "Aeroporto verso cui stai volando", // translated
  inboundFlightNumber: "Numero del volo in arrivo", // translated
  outboundFlightNumber: "Numero del volo di andata", // translated
  inboundAirlineName: "Nome della compagnia aerea in arrivo", // translated
  outboundAirlineName: "Nome della compagnia aerea di partenza", // translated
  tripMode: "Modalità Viaggio", // translated
  airportToPoint: "Aeroporto al punto", // translated
  pointToAirport: "Punta all'aeroporto", // translated
  roundTrip: "Andata e ritorno", // translated
  destinationPoint: "Punto di destinazione", // translated
  originPoint: "Punto di origine", // translated
  transferType: "Tipo di trasferimento", // translated
  min: "minimo", // translated
  max: "Massimo", // translated
  pieces: "Pezzi", // translated
  cancelationIs: "la cancellazione è", // translated
};

export default transfers;
